module.exports = __webpack_public_path__ + "static/media/be-together-iphone.b0766e90.png";